import React, { Component } from 'react';
import Constants from '../../Config/Config';

class TopMat extends Component {
	render() {
		const {topMatTotal, selectedTopMat, selectedMatSize} = this.props;
    return (
      <tr>
  			<th>Top Mat</th>
        <td>{selectedTopMat.getIn(['title', 'rendered']) !== undefined && parseFloat(selectedMatSize) !== 0 ? selectedTopMat.getIn(['title', 'rendered']) : "None Selected"}</td>
        <td>{Constants.Currency}{parseFloat(selectedMatSize) !== 0 ? topMatTotal : '0'}</td>
      </tr>
    );
	}
}
export default TopMat;